import { areObjectsEquivalent, configurationSettings, defaultDomainConfig, initialise } from '@vista-digital/occ-domain';
import { useEffect, useRef } from 'react';
export const useDomainConfig = (config) => {
    const hasDomainInitialised = useRef(!areObjectsEquivalent(defaultDomainConfig, configurationSettings.data));
    if (!hasDomainInitialised.current && !!config) {
        initialise(config);
        hasDomainInitialised.current = true;
    }
    useEffect(() => {
        if (!config)
            return;
        configurationSettings.setConfig(config);
    }, [config]);
};
//# sourceMappingURL=use-domain-config.js.map